module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.hideUploadPopup()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    attrs: {
      "id": "dropTarget"
    }
  }, [_c('span', {
    attrs: {
      "id": "dropText"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('fileDrop.dropKml'))
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75f329c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileDrop.vue
// module id = 639
// module chunks = 2